<template>
  <PlaceholderPantalla
    titulo="Calculadora de Precios de Impresión"
    subtitulo="Herramienta para calcular precios de trabajos de impresión"
    descripcion="Calculadora inteligente que te ayuda a determinar el precio de venta ideal para cada trabajo de impresión. Ingresa los costos de materiales (papel, tintas), mano de obra, gastos indirectos, tiempo de producción, y el margen de utilidad deseado. La calculadora te sugiere el precio óptimo considerando competencia, punto de equilibrio, y diferentes escenarios de rentabilidad por volumen."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Seleccionar producto de impresión del catálogo o crear nuevo',
  'Cálculo automático de costo de materiales (papel, tintas, consumibles)',
  'Configurar cantidad de impresiones',
  'Ingreso de especificaciones (tamaño, colores, acabados)',
  'Cálculo de costo de mano de obra según tiempo estimado',
  'Asignación proporcional de gastos indirectos (luz, renta, depreciación)',
  'Cálculo de costo total de producción',
  'Definir margen de utilidad deseado (%)',
  'Cálculo de precio de venta sugerido',
  'Tabla de precios por volumen (descuentos por escala)',
  'Simulador de escenarios (¿qué pasa si...?)',
  'Comparación con precios de competencia',
  'Cálculo de punto de equilibrio',
  'Análisis de sensibilidad (cambio en costos)',
  'Historial de cálculos guardados',
  'Gráficas de composición de costos',
  'Exportar análisis a PDF',
  'Aplicar precio calculado al catálogo de productos'
]

const datosManejados = [
  'Producto de impresión seleccionado',
  'Cantidad de impresiones',
  'Tamaño y especificaciones',
  'Lista de insumos necesarios',
  'Costo por insumo (papel, tintas, etc.)',
  'Cantidad de cada insumo',
  'Costo total de materiales',
  'Tiempo estimado de producción',
  'Costo de mano de obra',
  'Porcentaje de gastos indirectos',
  'Gastos indirectos (luz, renta, depreciación)',
  'Costo total de producción',
  'Costo unitario',
  'Margen de utilidad deseado (%)',
  'Precio de venta sugerido unitario',
  'Precio de venta total',
  'Tabla de precios por volumen',
  'Precios de competencia (referencia)',
  'Punto de equilibrio (unidades)',
  'Rentabilidad proyectada',
  'Fecha del cálculo',
  'Notas y observaciones'
]
</script>
